import React from "react";
import { PaziaModalBlank } from "./PaziaModalBlank";

export type PaziaModalSize =
  | "sm"
  | "md"
  | "lg"
  | "xl"
  | "2xl"
  | "3xl"
  | "4xl"
  | "5xl"
  | "6xl"
  | "7xl"
  | "90%"
  | "full";
export interface PaziaModalProps {
  onCloseRequest: () => void;
  id: string;
  isOpen: boolean;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  size?: PaziaModalSize;
}
export const PaziaModal = ({
  onCloseRequest,
  isOpen,
  id,
  children,
  style,
  className,
  size,
}: PaziaModalProps) => {
  return (
    <PaziaModalBlank
      modalOpen={isOpen}
      onCloseRequest={onCloseRequest}
      id={id}
      className={className}
      size={size}
      style={style}
    >
      {children}
    </PaziaModalBlank>
  );
};
